import React, { useMemo } from 'react'
import Chart from 'react-apexcharts'

export default function ApexChartConsumo({
  series = [],
  colors = [],
  valueTotals = [],
  height = '100%'
}) {
  const localTema = localStorage.getItem('tema')

  const options = useMemo(() => {
    return {
      chart: { type: 'bar' },
      plotOptions: {
        bar: {
          borderRadius: 4,
          horizontal: true,
          barHeigth: '90%'
        }
      },
      legend: {
        fontSize: '18px !important',
        labels: {
          colors: localTema === 'escuro' ? '#fff' : '#000'
        },
        itemMargin: {
          horizontal: 50
        },
        markers: {
          width: 20,
          height: 20,
          radius: 50,
          offsetX: -10
        }
      },
      stroke: { colors: ['transparent'], width: 10 },
      dataLabels: {
        enabled: true,
        dropShadow: { enabled: true },
        style: { colors: ['#fff'], fontSize: '20px' },
        formatter: function (val, opt) {
          const vt = valueTotals?.[opt.seriesIndex]?.data ?? ''
          return `${vt} (${val == 100 ? val : val.toFixed(2)}%)`
        }
      },
      tooltip: {
        y: {
          formatter: function (val) {
            if (val === null || val === undefined) return ''
            return `${Number(val).toFixed(2)}%`
          }
        }
      },
      colors,
      xaxis: {
        type: 'category',
        max: 100,
        style: {
          fontSize: '18px',
          color: '#fff'
        },
        axisBorder: {
          color: localTema === 'escuro' ? '#fff' : '#000'
        },
        labels: {
          style: {
            fontSize: '16px !important',
            cssClass:
              localTema === 'escuro'
                ? 'apexcharts-xaxis-label-noturno'
                : 'apexcharts-xaxis-label'
          },
          offsetY: 2,
          formatter: function (val) {
            return `${val}%`
          }
        }
      },
      yaxis: {
        show: false
      }
    }
  }, [colors, valueTotals, localTema])

  return (
    <div className="chart-container">
      <div className="chart-wrapper" id="chart">
        <Chart
          options={options}
          series={series || []}
          type="bar"
          height={height}
        />
      </div>
      <div id="html-dist" />
    </div>
  )
}
